const enLists = require('@/assets/lang/en/index.js')

module.exports = {
  ...enLists,
  systemBase: require('./en-US/en-US-systemBase'),
  label: require('./en-US/en-US-label'),
  tableHeader: require('./en-US/en-US-tableHeader'),
  button: require('./en-US/en-US-button'),
  tip: require('./en-US/en-US-tip'),
  tabName: require('./en-US/en-US-tabName'),
  modalTitle: require('./en-US/en-US-modalTitle')
}